import client from "@/api/client/inputs-catalog";
import type { ResponseConfig } from "@/api/client/inputs-catalog";
import type { GetProductQueryResponse, GetProductQueryParams } from "../../types/GetProduct";

/**
     * @link /v1/product
     */
export async function getProduct (params: GetProductQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetProductQueryResponse>["data"]> {
    const { data: resData } = await client<GetProductQueryResponse>({
        method: "get",
        url: `/v1/product`,
        params,
        ...options
    });
    
    return resData;
};